import {
  Chip,
  TextV2,
  SvgLock2Bold,
  SvgHierarchy8Bold,
} from '@insights-ltd/design-library/components';
import { Link as RouterLink } from 'react-router';
import Link from '@mui/material/Link';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type {
  ReactElement,
  JSXElementConstructor,
  ReactNode,
  ReactPortal,
} from 'react';

const StyledLock = styled(SvgLock2Bold)(() => ({
  fill: 'currentcolor',
  transform: 'scale(67%)',
}));

const StyledHierarchy8Bold = styled(SvgHierarchy8Bold)(({ theme }) => ({
  width: '1rem',
  fill: theme.palette.blue.dark,
  marginRight: '.5rem',
  marginTop: '.1rem',
  transform: 'scale(120%)',
}));

const NameColumn = ({
  organisationCount,
  id,
  name,
  visibility,
}: {
  organisationCount: number;
  id: any;
  name:
    | string
    | number
    | boolean
    | ReactElement<any, string | JSXElementConstructor<any>>
    | Iterable<ReactNode>
    | ReactPortal
    | null
    | undefined;
  visibility: string;
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '400px',
      }}
    >
      {organisationCount > 1 && <StyledHierarchy8Bold />}
      <Link component={RouterLink} to={`/teams/${id}`}>
        <TextV2 variant="bodyBold" color="primary">
          {name}
        </TextV2>
      </Link>
      {visibility === 'PRIVATE' && (
        <Chip
          color="grey"
          icon={<StyledLock />}
          label={t('ui.event-management.teams.permissions.label-private')}
          sx={{
            marginLeft: '1rem',
          }}
        />
      )}
    </Box>
  );
};

export default NameColumn;
